import { type Dispatch, type SetStateAction, useCallback, useRef } from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { normalizeNodeType } from 'modules/job_catalog/lib/nodesUtils'

import { type CustomNode } from './types'

interface UseToggleExpandProps {
  setNodes: Dispatch<SetStateAction<CustomNode[]>>
  nodes: CustomNode[]
}

const useToggleExpand = ({ setNodes, nodes }: UseToggleExpandProps) => {
  const nodesRef = useRef(nodes)
  nodesRef.current = nodes

  const onToggleExpand = useCallback(
    (nodeId: string) => {
      const targetNode = nodesRef.current.find((n) => n.id === nodeId)
      if (targetNode) {
        const wasExpanded = targetNode.data.expanded
        if (wasExpanded) {
          track(trackingEvents.jobCatalog.collapseNodeSubmit, {
            event_category: 'Organizations',
            node_type: normalizeNodeType(targetNode.data.type),
            node_id: nodeId,
            node_name: targetNode.data.name,
          })
        } else {
          track(trackingEvents.jobCatalog.expandNodeSubmit, {
            event_category: 'Organizations',
            node_type: normalizeNodeType(targetNode.data.type),
            node_id: nodeId,
            node_name: targetNode.data.name,
            children_count: targetNode.data.childrenCount,
          })
        }
      }

      setNodes((nds) =>
        nds.map((n) => {
          if (n.id === nodeId) {
            return {
              ...n,
              data: { ...n.data, expanded: !n.data.expanded },
            }
          }
          return n
        })
      )
    },
    [setNodes]
  )

  return { onToggleExpand }
}

export default useToggleExpand
